(function () {
  function initPpv2Modal(root) {
    if (!root) return;

    const modal = root.querySelector('[data-ppv2-modal]');
    if (!modal || modal.dataset.ppv2ModalInit === 'true') return;

    const mediaMain = root.querySelector('.ppv2-mediaMain');
    const mainImg = root.querySelector('[data-ppv2-main]');
    const modalContent = modal.querySelector('.ppv2-imageModal__content');
    const modalImg = modal.querySelector('[data-ppv2-modal-img]');
    const modalCaption = modal.querySelector('[data-ppv2-modal-caption]');
    const closeEls = Array.from(modal.querySelectorAll('[data-ppv2-modal-close]'));
    const dragHandle = modal.querySelector('[data-ppv2-modal-drag]');
    const titleEl = root.querySelector('.ppv2-sidebarTitle');

    if (!mediaMain || !mainImg || !modalContent || !modalImg) return;

    modal.dataset.ppv2ModalInit = 'true';

    let lastFocusedElement = null;
    let dragState = null;

    const getTitle = function () {
      return titleEl ? titleEl.textContent.trim() : '';
    };

    const setModalOffset = function (x, y) {
      modalContent.style.setProperty('--ppv2-modal-offset-x', x + 'px');
      modalContent.style.setProperty('--ppv2-modal-offset-y', y + 'px');
    };

    const resetModalOffset = function () {
      setModalOffset(0, 0);
    };

    const closeAnyOpenModal = function () {
      document.querySelectorAll('.ppv2-imageModal.is-open').forEach(function (openModalEl) {
        openModalEl.classList.remove('is-open');
        openModalEl.setAttribute('aria-hidden', 'true');
        const openModalContent = openModalEl.querySelector('.ppv2-imageModal__content');
        if (openModalContent) {
          openModalContent.classList.remove('is-dragging');
          openModalContent.style.setProperty('--ppv2-modal-offset-x', '0px');
          openModalContent.style.setProperty('--ppv2-modal-offset-y', '0px');
        }
      });
      document.body.classList.remove('ppv2-modal-open');
    };

    const openModal = function () {
      const src = mainImg.currentSrc || mainImg.getAttribute('src');
      if (!src) return;

      closeAnyOpenModal();
      lastFocusedElement = document.activeElement;
      modalImg.setAttribute('src', src);
      modalImg.setAttribute('alt', mainImg.getAttribute('alt') || getTitle());

      if (modalCaption) {
        modalCaption.textContent = getTitle() || mainImg.getAttribute('alt') || '';
      }

      modalContent.classList.remove('is-dragging');
      resetModalOffset();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ppv2-modal-open');
      modalContent.focus();
    };

    const closeModal = function () {
      modalContent.classList.remove('is-dragging');
      dragState = null;
      resetModalOffset();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ppv2-modal-open');
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    };

    const updateDragPosition = function (clientX, clientY) {
      if (!dragState) return;
      const rect = modalContent.getBoundingClientRect();
      const maxX = Math.max(0, (window.innerWidth - rect.width) / 2 - 12);
      const maxY = Math.max(0, (window.innerHeight - rect.height) / 2 - 12);
      const nextX = dragState.originX + (clientX - dragState.startX);
      const nextY = dragState.originY + (clientY - dragState.startY);
      const clampedX = Math.max(-maxX, Math.min(maxX, nextX));
      const clampedY = Math.max(-maxY, Math.min(maxY, nextY));
      setModalOffset(clampedX, clampedY);
    };

    const onDragMove = function (event) {
      updateDragPosition(event.clientX, event.clientY);
    };

    const onDragEnd = function () {
      modalContent.classList.remove('is-dragging');
      dragState = null;
      document.removeEventListener('pointermove', onDragMove);
      document.removeEventListener('pointerup', onDragEnd);
      document.removeEventListener('pointercancel', onDragEnd);
    };

    mediaMain.addEventListener('click', function (event) {
      if (event.target.closest('[data-ppv2-media-prev], [data-ppv2-media-next]')) return;
      openModal();
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.target.closest('.ppv2-imageModal__content')) return;
      closeModal();
    });

    if (dragHandle) {
      dragHandle.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button')) return;
        if (event.button !== 0) return;
        event.preventDefault();
        const offsetX = parseFloat(modalContent.style.getPropertyValue('--ppv2-modal-offset-x')) || 0;
        const offsetY = parseFloat(modalContent.style.getPropertyValue('--ppv2-modal-offset-y')) || 0;
        dragState = {
          startX: event.clientX,
          startY: event.clientY,
          originX: offsetX,
          originY: offsetY,
        };
        modalContent.classList.add('is-dragging');
        document.addEventListener('pointermove', onDragMove);
        document.addEventListener('pointerup', onDragEnd);
        document.addEventListener('pointercancel', onDragEnd);
      });
    }

    if (!document.body.dataset.ppv2ModalEscapeListener) {
      document.body.dataset.ppv2ModalEscapeListener = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeAnyOpenModal();
      });
    }
  }

  function initAllPpv2Modals() {
    document.querySelectorAll('.ppv2').forEach(initPpv2Modal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPpv2Modals);
  } else {
    initAllPpv2Modals();
  }

  document.addEventListener('product-info:loaded', function (event) {
    const root = event.target.querySelector('.ppv2');
    if (root) initPpv2Modal(root);
  });
})();
